<template>
    <fade-loader :loading="!value.loaded" :loaded="value.loaded">
        <div class="toolbox-content">
            <v-tabs class="sr-tabs">
              <v-tab>Daten</v-tab>
              <v-tab>Verknüpft (4)</v-tab>
            </v-tabs>
            <h3>Edit my GeoObject here :)</h3>
          <div class="formItem">
            <label>Input</label>
            <div class="placeholder-readonly">Kein Eintrag</div>
          </div>
            <div class="formItem">
              <label>Input</label>
                <v-text-field solo flat hide-details class="sr-input" label="Name" placeholder="Enter name" value="Objekt im Zentrum von Wabern"></v-text-field>
                <v-text-field solo flat hide-details readonly class="sr-input" label="Name" placeholder="Enter name" value="Objekt im Zentrum von Wabern"></v-text-field>
            </div>
          <div class="formItem">
            <label>Input</label>
            <small class="unit">m<sup>2</sup></small>
            <v-text-field solo flat hide-details class="sr-input" label="Name" placeholder="Enter name" value="Objekt im Zentrum von Wabern"></v-text-field>
          </div>
          <div class="formItem">
            <label>Textarea</label>
            <v-textarea
              class="sr-textarea"
              hide-details
              value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through."
            ></v-textarea>
            <v-textarea
              class="sr-textarea"
              hide-details
              readonly
              value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through."
            ></v-textarea>
          </div>
          <div class="formItem">
            <v-menu
              v-model="menu2"
              :close-on-content-click="true"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                v-model="date"
                solo
                flat
                hide-details
                class="sr-input icon-calendar"
                v-on="on"
              ></v-text-field>
                <v-text-field
                  v-model="date"
                  solo
                  flat
                  hide-details
                  readonly
                  class="sr-input icon-calendar"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" @input="menu2 = false" no-title class="sr-datepicker"></v-date-picker>
            </v-menu>
          </div>
            <div class="formItem">
              <label>Select</label>
              <v-select
                hide-details
                class="sr-select"
                :items="items"
                label="Standard"
              ></v-select>
              <v-select
                hide-details
                disabled
                class="sr-select"
                :items="items"
                label="Standard"
              ></v-select>
            </div>
          <div class="formItem">
            <label>Light Switch</label>
            <v-switch
              class="sr-switch"
              label="In Immobilienbörse mit einem langen wording"
            ></v-switch>
            <v-switch
              disabled
              class="sr-switch"
              label="In Immobilienbörse"
            ></v-switch>
          </div>
          <div class="formItem">
            <v-btn
              class="sr-button"
              text
            >
              Login
            </v-btn>
            <v-btn
              class="sr-button"
              text
              disabled
            >
              Login
            </v-btn>
          </div>
          <div class="formItem">
            <label>Image</label>
            <div class="img icon-search">
              <img src="/assets/img/placeholder-img.jpg"/>
              <span><button class="btn-icon-only icon-trash-small"></button>Ich bin eine Bildunterschrift</span>
            </div>
          </div>
          <div class="formItem">
            <label>Image</label>
            <div class="img icon-search readonly">
              <img src="/assets/img/placeholder-img.jpg"/>
              <span><button class="btn-icon-only icon-trash-small"></button>Ich bin eine Bildunterschrift</span>
            </div>
          </div>
          <div class="formItem">
            <div class="droparea">
              <i class="icon-plus"></i>
              Bild hier ablegen
            </div>
          </div>
          <div class="formItem">
            <label>Datei</label>
            <ul class="entry-list">
              <li class="icon-document">
                <v-progress-circular :size="16" :width="2" color="#2ED1DF" indeterminate></v-progress-circular>
                Bauplan_mit_langem_wording_2019.pdf
              </li>
              <li class="icon-document"><a href="#" title="#" class="icon-trash-small"></a>Bauplan_mit_langem_wording_2019.pdf</li>
              <li class="icon-document"><a href="#" title="#" class="icon-trash-small"></a>Bauplan 2019.pdf</li>
            </ul>
          </div>
          <h3>Kontaktpersonen</h3>
          <div class="formItem">
            <ul class="entry-list">
              <li><a href="#" title="#" class="icon-trash-small"></a>Person 1</li>
            </ul>
          </div>
          <div class="formItem">
            <label>Wohnfläche</label>
            <v-text-field solo flat hide-details class="sr-input" label="Name" placeholder="Enter name" value="Objekt im Zentrum von Wabern"></v-text-field>
          </div>
          <div class="formItem">
            <label>Grundstücksfläche</label>
            <v-text-field solo flat hide-details class="sr-input" label="Name" placeholder="Enter name" value="Objekt im Zentrum von Wabern"></v-text-field>
          </div>
          <div class="formItem">
            <ul class="entry-list">
              <li><a href="#" title="#" class="icon-trash-small"></a>Person 1</li>
            </ul>
          </div>
          <div class="formItem">
            <label>Wohnfläche</label>
            <v-text-field solo flat hide-details class="sr-input" label="Name" placeholder="Enter name" value="Objekt im Zentrum von Wabern"></v-text-field>
          </div>
          <div class="formItem">
            <label>Grundstücksfläche</label>
            <v-text-field solo flat hide-details class="sr-input" label="Name" placeholder="Enter name" value="Objekt im Zentrum von Wabern"></v-text-field>
          </div>
          <v-expansion-panels class="sr-accordion">
            <v-expansion-panel>
              <v-expansion-panel-header>Item</v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="formItem">
                  <label>Input</label>
                  <v-text-field solo flat hide-details readonly class="sr-input" label="Name" placeholder="Enter name" value="Objekt im Zentrum von Wabern"></v-text-field>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <h3>Feldzuweisungen</h3>
          <div class="form-group">
            <div class="form-label"><span>im Import gefundene Felder</span></div>
            <div class="grid">
              <div class="col-1-2">
                <div class="formItem button">
                  <label>Input</label>
                  <v-text-field solo flat hide-details class="sr-input" label="Name" placeholder="Enter name" value="Objekt im Zentrum von Wabern"></v-text-field>
                  <button class="btn-icon-only icon-trash-small"></button>
                </div>
              </div>
              <div class="col-1-2">
                <div class="formItem">
                  <label>Select</label>
                  <v-select
                    class="sr-select"
                    :items="items"
                  ></v-select>
                </div>
              </div>
              <div class="col-1-2">
                <div class="formItem">
                  <label>Input</label>
                  <v-text-field solo flat hide-details class="sr-input" label="Name" placeholder="Enter name" value="Objekt im Zentrum von Wabern"></v-text-field>
                </div>
              </div>
              <div class="col-1-2">
                <div class="formItem">
                  <label>Select</label>
                  <v-select
                    class="sr-select"
                    :items="items"
                  ></v-select>
                </div>
              </div>
            </div>
            <div class="form-label right"><span>Felder im gewählten Layer</span></div>
          </div>

          <div class="form-group">
            <div class="form-label"><span>Objekte verknüpfen (4)</span></div>
            <div class="formItem formCheckbox single-right">
              <input type="checkbox">
              <label><i></i></label>
            </div>
            <div class="formItem formCheckbox">
              <input type="checkbox">
              <label>
                <i></i>
                <span>
                    Erschließung
                    <small>ID 23453453453</small>
                  </span>
              </label>
            </div>
            <div class="formItem formCheckbox">
              <input type="checkbox">
              <label>
                <i></i>
                <span>
                    Erschließung
                    <small>ID 23453453453</small>
                  </span>
              </label>
            </div>
            <div class="formItem formCheckbox single-right">
              <input type="checkbox">
              <label><i></i></label>
            </div>
            <div class="formItem formCheckbox">
              <input type="checkbox">
              <label>
                <i></i>
                <span>
                    Erschließung
                    <small>ID 23453453453</small>
                  </span>
              </label>
            </div>
            <div class="form-label right"><span>Vektor des Objekts kopieren</span></div>
          </div>

          <v-dialog
            v-model="dialog"
            content-class="sr-overlay"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="red lighten-2"
                dark
                v-on="on"
              >
                Click Me
              </v-btn>
            </template>

            <div class="overlay-header">
              <button class="btn-icon icon-close" @click="overlay = false"></button>
              Bildunterschrift des Bildes
            </div>
            <img class="overlay-img" src="/assets/img/placeholder-img-big.jpg"/>
          </v-dialog>
          <div class="formItem">
            <v-btn @click="$alert.info('bin da', {duration: 0})">Test</v-btn>
          </div>
        </div>
    </fade-loader>
</template>

<script>
  export default {
    props: {
      value: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped>

</style>
